export default Object.freeze([
    {text:'支出',value:'-'},
    {text:'收入',value:'+'}
]);